module.exports = __webpack_public_path__ + "img/bg-carbon.accdd4e2.jpg";